export const API_ORIGIN = process.env.REACT_APP_API_ORIGIN || 'http://localhost:4000';
export const API_BASE = `${API_ORIGIN}/api`;

export const apiGet = async (path) => {
  const res = await fetch(`${API_BASE}${path}`);
  if (!res.ok) {
    throw new Error(`Request failed: ${res.status}`);
  }
  return res.json();
};

export const apiPost = async (path, data, isMultipart = false) => {
  const options = isMultipart
    ? { method: 'POST', body: data }
    : {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      };

  const res = await fetch(`${API_BASE}${path}`, options);

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Request failed: ${res.status}`);
  }

  return res.json();
};
